import React from 'react'
import styled from 'styled-components'
import { soupItems, sallataItems, antipastaItems, pizzaItems, baguetteItems, calzoneItems, conchasItems, pastaItems, rizotoItems, secondiItems, embelsiraItems, pijeItems } from '../data/menu'
import { useLocation } from 'react-router-dom'
import {FaArrowAltCircleUp} from 'react-icons/fa'
import {RiArrowGoBackLine} from 'react-icons/ri'
import { useHistory } from 'react-router';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 20px 0;
    position: relative;
`

const ItemBox = styled.div`
    background-color: #333;
    max-width: 200px;
    margin: 5px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 10px;
    box-shadow: 3px 3px 15px rgba(0,0,0, 0.3);
    height: 150px;
    width: 200px;
    transition: all .3s ease;

    @media screen and (max-width: 500px) {
        width: 130px;
        height: 130px;
    }

    &:hover {
        transform: scale(1.04);
    }
`

const Title = styled.h3`
    margin-bottom: 5px;
    color: #fff;
    font-size: 16px;
    text-align: center;
`

const Desc = styled.p`
    margin-top: 3px;
    color: #fff;
    font-size: 11px;
    text-transform: lowercase;
    padding-left: 3px;
    padding-right: 3px;
    text-align: center;
`

const Price = styled.span`
    color: #fff;
    font-size: 14px;
    font-style: italic;
    font-weight: bold;
`

const BtnContainer = styled.div`
    position: fixed;
    bottom: 10px;
    left: 0%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const BackBtn = styled.a`
    color: #f9f9f9;
    padding: 10px;
    font-size: 26px;
    cursor: pointer;
    background-color: darkred;
    display: flex;
`
const TopBtn = styled.a`
    color: #f9f9f9;
    padding: 5px;
    font-size: 26px;
    cursor: pointer;
    transition: all 1s ease;
    padding: 10px;
    background-color: darkred;
    display: flex;
`

const TitleName = styled.h2`
    text-align: center;
    color: #fff;
    background: #333;
    width: 150px;
    margin: 50px auto;
    padding: 10px 30px;
    border-radius: 10px;
    box-shadow: 5px 5px 15px rgba(0,0,0,0.5);

`


function CatListItems() {   

    const history = useHistory();

    const handleBack = () => {
        history.goBack();
    }

    let location = useLocation()

    if(location.pathname === "/supa") {
        return  <div>
            <TitleName>Supa</TitleName>
            <Container>
        {soupItems.map(item=> (
            <ItemBox key={item.id}>
                <Title>{item.alb}</Title>
                {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                <Price>{item.price}L</Price>
            </ItemBox>
        ))}
        <BtnContainer>
            <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
            <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
        </BtnContainer>
        </Container>
        </div>
    } else if (location.pathname === "/zuppe") {
        return  <div>
             <TitleName>Zuppe</TitleName>
            <Container>
            {soupItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
        </div>
    } else if(location.pathname === "/soups") {
        return <div>
        <TitleName>Soups</TitleName>
        <Container>
            {soupItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/sallata") {
        return <div> 
        <TitleName>Sallata</TitleName>
        <Container>
            {sallataItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/insalate") {
        return <div>
        <TitleName>Insalate</TitleName>
        <Container>
            {sallataItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/salads") {
        return <div>
        <TitleName>Salads</TitleName>
         <Container>
            {sallataItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/antipasta") {
        return <div>
        <TitleName>Antipaste</TitleName>
        <Container>
            {antipastaItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/antipaste") {
        return <div>
        <TitleName>Antipaste</TitleName>
        <Container>
            {antipastaItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/appetizers") {
        return <div>
        <TitleName>Appetizers</TitleName>
        <Container>
            {antipastaItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/pizza") {
        return <div>
        <TitleName>Pizza</TitleName>
        <Container>
            {pizzaItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/pizza-ita") {
        return <div>
        <TitleName>Pizza</TitleName>
        <Container>
            {pizzaItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/pizza-eng") {
        return <div>
        <TitleName>Pizza</TitleName>
        <Container>
            {pizzaItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/baguette") {
        return <div>
        <TitleName>Baguette</TitleName>
        <Container>
            {baguetteItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/baguette-ita") {
        return <div>
        <TitleName>Baguette</TitleName>
        <Container>
            {baguetteItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/baguette-eng") {
        return <div>
        <TitleName>Baguette</TitleName> 
        <Container>
            {baguetteItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/calzone") {
        return <div>
        <TitleName>Calzone</TitleName>
        <Container>
            {calzoneItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/calzone-ita") {
        return <div>
        <TitleName>Calzone</TitleName>
        <Container>
            {calzoneItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/calzone-eng") {
        return <div>
        <TitleName>Calzone</TitleName>
        <Container>
            {calzoneItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/conchas") {
        return <div>
        <TitleName>Conchas</TitleName>
        <Container>
            {conchasItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/conchas-ita") {
        return <div>
        <TitleName>Conchas</TitleName>
        <Container>
            {conchasItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/conchas-eng") {
        return <div>
        <TitleName>Conchas</TitleName>
        <Container>
            {conchasItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/pasta") {
        return <div>
        <TitleName>Pasta</TitleName>
        <Container>
            {pastaItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/paste") {
        return <div>
        <TitleName>Pasta</TitleName>
        <Container>
            {pastaItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/pastas") {
        return <div>
        <TitleName>Pasta</TitleName>
        <Container>
            {pastaItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/risoto") {
        return <div>
        <TitleName>Rizoto</TitleName>
        <Container>
            {rizotoItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/rissoto") {
        return <div>
        <TitleName>Rissoto</TitleName>
        <Container>
        {rizotoItems.map(item=> (
            <ItemBox key={item.id}>
                <Title>{item.ita}</Title>
                {item.ingIta && <Desc>({item.ingIta})</Desc>}
                <Price>{item.price}L</Price>
            </ItemBox>
        ))}
        <BtnContainer>
            <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
            <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
        </BtnContainer>
        </Container>
        </div>
    } else if(location.pathname === "/rissoto-eng") {
        return <div>
        <TitleName>Rissoto</TitleName>
        <Container>
            {rizotoItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/pjata-kryesore") {
        return <div>
        <TitleName>Pjata Kryesore</TitleName>
        <Container>
            {secondiItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/secondi-piatti") {
        return <div>
        <TitleName>Secondi Piatti</TitleName>
        <Container>
            {secondiItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/main-dishes") {
        return <div>
        <TitleName>Main Dishes</TitleName>
        <Container>
            {secondiItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/embelsira") {
        return <div>
        <TitleName>ëmbëlsira</TitleName>
        <Container>
            {embelsiraItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/dolci") {
        return <div>
        <TitleName>Dolci</TitleName>
        <Container>
            {embelsiraItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/desserts") {
        return <div>
        <TitleName>Desserts</TitleName>
        <Container>
            {embelsiraItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/pijet") {
        return <div>
        <TitleName>Pijet</TitleName>
        <Container>
            {pijeItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.alb}</Title>
                    {item.ingAlb && <Desc>({item.ingAlb})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/bevande") {
        return <div>
        <TitleName>Bevande</TitleName>
        <Container>
            {pijeItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.ita}</Title>
                    {item.ingIta && <Desc>({item.ingIta})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    } else if(location.pathname === "/drinks") {
        return <div>
        <TitleName>Drinks</TitleName>
        <Container>
            {pijeItems.map(item=> (
                <ItemBox key={item.id}>
                    <Title>{item.eng}</Title>
                    {item.ingEng && <Desc>({item.ingEng})</Desc>}
                    <Price>{item.price}L</Price>
                </ItemBox>
            ))}
            <BtnContainer>
                <TopBtn href="#top" ><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
            </Container>
            </div>
    }
    

}

export default CatListItems
